import { render, staticRenderFns } from "./mechanism.vue?vue&type=template&id=b4f37ed6"
import script from "./mechanism.vue?vue&type=script&lang=js"
export * from "./mechanism.vue?vue&type=script&lang=js"
import style0 from "./mechanism.vue?vue&type=style&index=0&id=b4f37ed6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports